<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper"  :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <navbar-component></navbar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->

        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div class="row mb-4">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    Upload So BASF02
                  </h6>
                  <button
                    class="btn btn-success btn-xs float-end"
                    @click="downloadSoTemplate"
                    type="button"
                  >
                    <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} Template
                  </button>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitSo"
                    method="POST"
                    enctype="multipart/form-data"
                  >
                    <div
                      class="d-flex justify-content-between align-items-baseline mb-2"
                    ></div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Warehouse Id</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchFulfillment"
                          v-model="fulfillmentSo"
                          label="code"
                          return-object
                          @search="asyncSearchFulfillment"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.code }} | {{ option.name }}
                          </template>
                        </v-select>

                        <div v-if="errors.fulfillment_center_id">
                          <div
                            v-for="error in errors.fulfillment_center_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >So Type</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <multiselect
                          @search-change="asyncLoadSoType"
                          v-model="soType"
                          :custom-label="customType"
                          :options="fetchSoType"
                          track-by="code"
                        >
                          <span slot="noResult"
                            >Oops! No elements found. Consider changing the
                            search query.</span
                          >

                        </multiselect>
                        <div v-if="errors.order_type">
                          <div
                            v-for="error in errors.order_type"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mb-3"
                      v-if="detailUser?.role?.name == 'superadmin'"
                    >
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Company</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchCustomer"
                          v-model="companySo"
                          label="name"
                          return-object
                          @search="asyncCustomer"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.code }} | {{ option.name }}
                          </template>
                        </v-select>
                        <div v-if="errors.customer_id">
                          <div
                            v-for="error in errors.customer_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >File</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="file"
                          ref="file"
                          class="form-control"
                          @change="handleFileUpload($event)"
                        />

                        <div v-if="errors.code">
                          <div
                            v-for="error in errors.code"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3" v-if="uploadSoResult">
                      <div class="col-lg-2">
                      </div>
                      <div class="col-lg-8">
                        <div class="table-responsive">
                          <table class="table table-hover">
                            <thead>
                              <th>Order No </th>
                            </thead>
                            <tbody>
                              <tr v-for="(data, index) in uploadSoResponse" :key="index">
                                <th>{{ data }}</th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>
                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    Upload Po BASF02
                  </h6>
                  <button
                    class="btn btn-success btn-xs float-end"
                    @click="downloadPoTemplate"
                    type="button"
                  >
                    <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} Template
                  </button>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitPo"
                    method="POST"
                    enctype="multipart/form-data"
                  >
                    <div
                      class="d-flex justify-content-between align-items-baseline mb-2"
                    ></div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Warehouse Id</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchFulfillment"
                          v-model="fulfillmentPo"
                          label="code"
                          return-object
                          @search="asyncSearchFulfillment"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.code }} | {{ option.name }}
                          </template>
                        </v-select>

                        <div v-if="errors.fulfillment_center_id">
                          <div
                            v-for="error in errors.fulfillment_center_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Po Type</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <multiselect
                          @search-change="asyncLoadPoType"
                          v-model="poType"
                          :custom-label="customType"
                          :options="fetchPoType"
                          track-by="code"
                        >
                          <span slot="noResult"
                            >Oops! No elements found. Consider changing the
                            search query.</span
                          >

                        </multiselect>
                        <div v-if="errors.po_type">
                          <div
                            v-for="error in errors.po_type"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mb-3"
                      v-if="detailUser?.role?.name == 'superadmin'"
                    >
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Company</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchCustomer"
                          v-model="companyPo"
                          label="name"
                          return-object
                          @search="asyncCustomer"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.code }} | {{ option.name }}
                          </template>
                        </v-select>
                        <div v-if="errors.customer_id">
                          <div
                            v-for="error in errors.customer_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >File</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="file"
                          ref="file"
                          class="form-control"
                          @change="handleFileUpload($event)"
                        />

                        <div v-if="errors.code">
                          <div
                            v-for="error in errors.code"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3" v-if="uploadPoResult">
                      <div class="col-lg-2">
                      </div>
                      <div class="col-lg-8">
                        <div class="table-responsive">
                          <table class="table table-hover">
                            <thead>
                              <th>Order No </th>
                            </thead>
                            <tbody>
                              <tr v-for="(data, index) in uploadPoResponse" :key="index">
                                <th>{{ data }}</th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>
                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
  <script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
// import DateRangePicker from "vue2-daterange-picker";
import multiselect from "vue-multiselect";
export default {
  name: "InterfaceBasf02",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    // DateRangePicker,
    multiselect,
  },
  data() {
    const startDate = new Date(); // new Date();
    const endDate = new Date();

    return {

      uploadSoResult:false,
      uploadSoResponse:[],
      uploadPoResult:false,
      uploadPoResponse:[],

      tableError: false,
      errorsData: [],
      file: "",
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      detailUser:{},
      errors: [],
      dateFilterStart: {
        startDate,
        endDate,
      },
      dateFilterEnd: {
        startDate,
        endDate,
      },
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },

      localeDetail: {
        format: "yyyy-mm-dd",
      },

      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(),
        ],
      },
      userData: "",
      regionCode: "",
      forms: { name: "", usernmae: "" },
      fetchFulfillment: [],
      fulfillmentPo: null,
      fulfillmentSo: null,

      fetchPoType: [],
      poType: null,

      fetchSoType: [],
      soType: null,

      fetchCustomer: [],
      companyPo: null,
      companySo: null,
    };
  },
  watch: {},
  methods: {
    customType(ev){
      return `${ev.code} | ${ev.name}`
    },
    loadPoType() {
      const baseURI =
        this.$settings.endPointFluxOms +
        "additional/get-data-wms-code?type=PO_TYP";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchPoType = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncLoadPoType(ev) {
      const baseURI =
        this.$settings.endPointFluxOms +
        "additional/get-data-wms-code?type=PO_TYP&code="+ev;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchPoType = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    loadSoType() {
      const baseURI =
        this.$settings.endPointFluxOms +
        "additional/get-data-wms-code?type=SO_TYP";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchSoType = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncLoadSoType(ev) {
      const baseURI =
        this.$settings.endPointFluxOms +
        "additional/get-data-wms-code?type=SO_TYP&code="+ev;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchSoType = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    loadFullfilment() {
      const baseURI =
        this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchFulfillment = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncSearchFulfillment(ev) {
      this.fetchFulfillment = [];
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/fulfillment/get-data-fulfillment?code=" +
        ev;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchFulfillment = response.data.datas.data;
          //console.log(this.fetchFulfillment);
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    loadCustomer() {
      const baseURI =
        this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncCustomer(code) {
      this.fetchCustomer = [];
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/customer/get-data-company-oms?code=" +
        code;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    resetForm() {},

    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    submitSo() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.fade(true);

          let formData = new FormData();
          // console.log(this.file);
          formData.append("fulfillment_center_id",this.fulfillmentSo?.fulfillment_center_id ? this.fulfillmentSo?.fulfillment_center_id : "");
          formData.append("order_type", this.soType?.code ? this.soType.code : "");
          formData.append("customer_id", this.companySo?.customer_id ? this.companySo.customer_id : "");
          formData.append("file", this.file);

          const baseURI =
            this.$settings.endPointFluxOms + "v2/interface/basf02/upload-so";
          this.$http
            .post(baseURI, formData)
            .then((response) => {
              this.success(response.data.datas);
              this.uploadSoResult = true;
              this.uploadSoResponse = response.data.datas;
              this.fade(false);
            })
            .catch((error) => {
              // console.log(error);
              this.loading();
              this.tableError = true;
              if (error.response) {
                if (error.response.status === 422) {
                  this.errorsData = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                  this.logout();
                } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },
    downloadSoTemplate() {
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/interface/basf02/download-template-so";

      var file_name = "template_so.xlsx";

      //var columnFilters = this.serverParams.columnFilters;

      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
    submitPo() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.fade(true);

          let formData = new FormData();
          // console.log(this.file);
          formData.append("fulfillment_center_id",this.fulfillmentPo?.fulfillment_center_id ? this.fulfillmentPo?.fulfillment_center_id : "");
          formData.append("po_type", this.poType?.code ? this.poType?.code : "");
          formData.append("customer_id", this.companyPo?.customer_id ? this.companyPo.customer_id : "");
          formData.append("file", this.file);

          const baseURI =
            this.$settings.endPointFluxOms + "v2/interface/basf02/upload-po";
          this.$http
            .post(baseURI, formData)
            .then((response) => {
              this.success(response.data.datas);
              this.uploadPoResult = true;
              this.uploadPoResponse = response.data.datas;
              this.fade(false);
            })
            .catch((error) => {
              // console.log(error);
              this.loading();
              this.tableError = true;
              if (error.response) {
                if (error.response.status === 422) {
                  this.errorsData = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                  this.logout();
                } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },
    downloadPoTemplate() {
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/interface/basf02/download-template-po";

      var file_name = "template_po.xlsx";

      //var columnFilters = this.serverParams.columnFilters;

      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // console.log(this.detailUser);
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "InterfaceBasf02Controller") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_upload) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    backForm() {
      window.location.href = "/flux-oms/asn-inbound";
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.loadFullfilment();
    this.fetchIt();
    this.loadPoType();
    this.loadSoType();
    this.loadCustomer();
  },
};
</script>
  <style scoped>
</style>